<template>
  <div class="ui-empty">
    <slot>
      <div v-if="type === 'empty'">
        <i class="fa fa-soundcloud" style="font-size: 3em;" />
        <div class="ui-empty-text">{{ v_text }}</div>
      </div>
      <div v-else>
        <i class="fa fa-exclamation-triangle" style="font-size: 3em;" />
        <div class="ui-empty-text">{{ v_text }}</div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'empty',
      validator() {
        return ['empty', 'error'];
      },
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    v_text() {
      if (!this.$props.text) {
        const textEnum = {
          'empty': '暂无数据',
          'error': '加载失败',
        };
        return textEnum[this.type] || this.text;
      }
      // 如果自定义了text，则直接返回
      return this.text;
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style>
.ui-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  min-height: 60px;
  color: gray;
  text-align: center;
}
</style>